module.exports = __webpack_public_path__ + "img/Weapon_35.7f5fbaa4.png";